<div class="map-stamp-container">
    <google-map
        width="100%"
        height="100%"
        [options]="options" 
        (mapInitialized)="onMapReady($event)"
        (mapClick)="onMapClick($event)"
    >
        <app-stamp-map-markers 
            [map]="map"
            [markers]="markers()" 
            [mapClickEvent]="mapClickEvent()" 
        />
    </google-map>
</div>
